import type { FormOpt } from './types'

function parseLabelWidthPx(raw: unknown): number | null {
  if (raw === undefined || raw === null) return null
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw
  if (typeof raw === 'string') {
    const s = raw.trim()
    if (s === '' || s === 'auto') return null
    const m = s.match(/^([\d.]+)(\s*px)?$/i)
    if (m) return Number.parseFloat(m[1])
    const n = Number.parseFloat(s)
    return Number.isFinite(n) ? n : null
  }
  return null
}

/** 透传给 el-form 的 formOpt：按语言在基准 label-width 上增加宽度（ja +50px，en +100px） */
export function applyLocaleLabelWidthToFormOpt(
  formOpt: FormOpt | undefined,
  locale: string,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...(formOpt ?? {}) }
  const hasKebab = Object.prototype.hasOwnProperty.call(out, 'label-width')
  const hasCamel = Object.prototype.hasOwnProperty.call(out, 'labelWidth')
  if (!hasKebab && !hasCamel) return out

  const raw = hasKebab ? out['label-width'] : out.labelWidth
  const base = parseLabelWidthPx(raw)
  if (base === null || base <= 0) return out

  let next = base
  if (locale === 'ja-JP') next += 30
  else if (locale === 'en-US') next += 50

  const s = `${Math.round(next)}px`
  out['label-width'] = s
  delete out.labelWidth
  return out
}
